// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tFEy","productName":"Table_productName__o_IaU"};